<template>
    <div class="container">
      <o-bread-crumb :url="{ name: 'MemberTier' }">
        <template v-slot:pageName>
          Member Tier
        </template>
        <template v-slot:pageDetail>
          Member Tier
        </template>
        <template v-slot:pageDescription>
          {{ page.cardTitle }}
        </template>
      </o-bread-crumb>
      <div class="d-flex justify-content-start col-md-6">
        <o-card :card-title="page.cardTitle" class="custom-table mw-450">
          <o-form @submit.prevent="change()" autocomplete="off">
            <div class="col">
                <hr>
                <o-form-group title="Expiration Duration" name="state" class="text-start mb-4 form-group-modern">
                    <span class="text-danger"> *</span>
                    <div class="expiration">
                        <div class="month me-3">
                            <label for="" class="mb-1">Month</label>
                            <o-input-text name="expiration_month" v-model="expiration.month" type="number" :required="true" class="modern-input" placeholder="0" />
                        </div>
                        <div class="day">
                            <label for="" class="mb-1">Day</label>
                            <o-input-text name="expiration_day" v-model="expiration.day" type="number" min="0" max="30" :required="true" class="modern-input" placeholder="0" />
                        </div>
                    </div>
                </o-form-group>
            </div>
            <div class="d-flex justify-content-center spinner-border text-primary spinner-position form" v-if="page.isLoading"></div>
            <div class="spinner" v-if='page.isLoading'></div>
            <div class="d-flex justify-content-between mt-4">
              <button @click.prevent="$router.push({ name: 'MemberTier' })" class="btn btn-light text-white px-4 fw-medium" type="button" style="background-color: #B9B9B9; border: none;">Cancel</button>
              <o-button :disabled='page.isLoading' type="submit" :variant="'primary'" class="px-4 text-white">
                Save
              </o-button>
            </div>
          </o-form>
        </o-card>
      </div>
    </div>
  </template>
  
  <script>
  import { OCard, OForm, OFormGroup, OInputText, OButton, OBreadCrumb } from '@/components/OmnihControl';
  import { reactive, ref, onMounted } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import store from '@/store';
  
  export default {
    name: 'AddMemberTier',
    components: {
      OCard,
      OForm,
      OFormGroup,
      OInputText,
      OButton,
      OBreadCrumb,
    },
    setup() {
      const router = useRouter();
      const route = useRoute();

      const cardTitle = (route.name == 'MemberTierDurationEdit') ? 'Update Duration' : 'Set Duration';

      const page = reactive({
        isLoading: false,
        cardTitle: cardTitle,
      });
  
      const validation = ref([]);

      const membertierDuration = reactive({
        corporate_id: '',
        expiration: '',
      });

      const expiration = reactive({
          month: 0,
          day: 0
      });
  
      onMounted(async () => {
          const corporate_id = await loadBusinessProfile();
          if (corporate_id) {
            load_state(corporate_id);
          }
      });

      async function loadBusinessProfile() {
          try {
              const businessProfile = await store.dispatch('Auth/getBusinessProfile');
              return businessProfile.corporate_id;
          } catch (error) {
              console.error('Error fetching business profile:', error);
              return null;
          }
      }
  
      async function load_state(id) {

        store.dispatch('membertierDuration/read',id).then((data) =>{
          
          membertierDuration.corporate_id = data.corporate_id
          membertierDuration.expiration = data.expiration

          expiration.month = Math.floor(Number(data.expiration) /  2592000);
          expiration.day = Math.floor((Number(data.expiration) - (expiration.month * 2592000)) / 86400);
        })
      }
  
      function change() {

        const data = {...membertierDuration}

        const month = expiration.month * 2592000;
        const day = expiration.day * 86400;

        const expiration_second = month + day;

        data.expiration = expiration_second;

        page.isLoading = true;
  
        store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
          data.corporate_id = businessProfile.corporate_id;
  
          if (route.name !== 'MemberTierDuration') {
            store.dispatch('membertierDuration/update', { data }).then(() => {
              router.push({ name: 'MemberTier' });
            }).catch((err) => {
              try {
                validation.value = JSON.parse(err.response.data.error);
              } catch (e) {
                console.error('Error parsing JSON:', e);
                validation.value = ['An unknown error occurred.'];
              }
            }).finally(() => {
              page.isLoading = false;
            });
          } else {
            store.dispatch('membertierDuration/create', { data }).then(() => {
              router.push({ name: 'MemberTier' });
            }).catch((err) => {
              try {
                validation.value = JSON.parse(err.response.data.error);
              } catch (e) {
                console.error('Error parsing JSON:', e);
                validation.value = ['An unknown error occurred.'];
              }
            }).finally(() => {
              page.isLoading = false;
            });
          }
        }).catch((err) => {
          console.error('Error fetching business profile:', err);
          validation.value = ['An unknown error occurred.'];
          page.isLoading = false;
        });
      }
  
      return {
        page,
        validation,
        router,
        change,
        expiration,
        membertierDuration
      };
    },
  };
  </script>
  
  <style scoped>
  .container {
    overflow-x: auto;
  }
  
  .table th,
  .table td {
    word-wrap: break-word;
    white-space: normal;
  }
  
  .form-group {
    width: 250px;
    text-align: left;
    padding-left: 16px;
  }
  
  .json-viewer pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    cursor: pointer;
    color: black;
  }
  
  .json-viewer span {
    cursor: pointer;
    color: black;
  }
  
  .json-viewer button {
    margin-left: 10px;
    cursor: pointer;
    background: none;
    border: none;
    color: black;
  }

  /* Modern Form Styles */
  .form-group-modern {
      font-weight: 500;
      color: #475569;
  }

  .modern-input {
      border: 1px solid #cbd5e1;
      border-radius: 6px;
      padding: 10px 14px;
      font-size: 14px;
      transition: border-color 0.2s, box-shadow 0.2s;
      width: 100%;
      margin-top: 6px;
  }

  .modern-input:focus {
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      outline: none;
  }

  .btn-save-modern {
      padding: 8px 24px;
      border-radius: 6px;
      font-weight: 600;
      transition: transform 0.1s, box-shadow 0.1s;
  }

  .btn-save-modern:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 8px -1px rgba(59, 130, 246, 0.5);
  }

  .expiration {
    display: flex;
    align-items: center;
    margin-top: 4px;
  }

  .expiration .month,
  .expiration .day {
    flex: 1;
  }

  /* Modern Alert Styles */
  .modern-alert {
    display: flex;
    align-items: flex-start;
    background-color: #fef2f2;
    border-left: 5px solid #ef4444;
    border-radius: 8px;
    padding: 10px 16px;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.05);
    animation: fadeIn 0.3s ease-out;
  }

  .modern-alert .alert-icon {
    flex-shrink: 0;
    margin-right: 12px;
    font-size: 16px;
    color: #ef4444;
  }

  .alert-list {
    margin: 0;
    font-size: 13px;
    color: #b91c1c;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-5px); }
    to { opacity: 1; transform: translateY(0); }
  }
  </style>
  